import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = { class: "under-cart__gift" };
var _hoisted_2 = { class: "cart-gift" };
var _hoisted_3 = { class: "cart-gift__box" };
var _hoisted_4 = { class: "cart-gift__main" };
var _hoisted_5 = { class: "cart-gift__label" };
var _hoisted_6 = { class: "cart-gift__bottom line" };
var _hoisted_7 = { class: "line__item line__item--mla" };
var _hoisted_8 = { class: "btn__label" };
import { computed, ref } from "vue";
import { pluralize } from "../../../../utils";
import ChooseGiftButton from "./ChooseGiftButton.vue";
import GiftsList from './GiftsList.vue';
import GiftsModal from "./GiftsModal.vue";
import Price from "../../../../components/Price.vue";
import { showPreloader } from "../../../../components/preloader";
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Gifts',
    props: {
        giftable: { type: Array, required: true },
        gifts: { type: Array, required: true },
        giftsUsed: { type: Number, required: true },
        giftsLeft: { type: Number, required: true },
        vipAvailable: Boolean,
        orderSum: { type: Number, required: true },
        minOrderSum: { type: Number, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var modal = ref();
        var chooseButtonMessage = computed(function () {
            if (props.giftsLeft) {
                if (props.giftsUsed) {
                    return pluralize(props.giftsLeft, 'Вам доступен ещё <strong>один подарок</strong>', 'Вам доступны ещё <strong>%% подарка</strong>', 'Вам доступны ещё <strong>%% подарков</strong>');
                }
                else {
                    return pluralize(props.giftsLeft, 'Вам доступен <strong>один подарок</strong>', 'Вам доступны <strong>%% подарка</strong>', 'Вам доступны <strong>%% подарков</strong>');
                }
            }
            return 'Подарки';
        });
        function showModal() {
            var _a;
            if (props.giftable.length) {
                (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
            }
            else {
                showPreloader();
                CartEventBus.emit('gifts:get_giftable');
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (__props.orderSum < __props.minOrderSum)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(ChooseGiftButton, { inactive: "" }, {
                                    default: _withCtx(function () { return [
                                        _cache[0] || (_cache[0] = _createTextVNode("Подарки доступны от\n            ", -1 /* CACHED */)),
                                        _createVNode(Price, { amount: __props.minOrderSum }, null, 8 /* PROPS */, ["amount"])
                                    ]; }),
                                    _: 1 /* STABLE */
                                }),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _cache[1] || (_cache[1] = _createTextVNode("Осталось добавить ещё на ", -1 /* CACHED */)),
                                        _createElementVNode("strong", null, [
                                            _createVNode(Price, {
                                                amount: __props.minOrderSum - __props.orderSum
                                            }, null, 8 /* PROPS */, ["amount"])
                                        ])
                                    ])
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
                            : (!__props.giftsUsed)
                                ? (_openBlock(), _createBlock(ChooseGiftButton, {
                                    key: 1,
                                    onClick: showModal,
                                    message: chooseButtonMessage.value,
                                    html: ""
                                }, null, 8 /* PROPS */, ["message"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(ChooseGiftButton, {
                                        onClick: showModal,
                                        message: chooseButtonMessage.value,
                                        html: ""
                                    }, null, 8 /* PROPS */, ["message"]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createVNode(GiftsList, { gifts: __props.gifts }, null, 8 /* PROPS */, ["gifts"]),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--4 btn--s btn--black btn--link",
                                                onClick: showModal
                                            }, [
                                                _createElementVNode("span", _hoisted_8, "Выбрать " + _toDisplayString(__props.giftsUsed + __props.giftsLeft === 1 ? 'другой' : 'другие'), 1 /* TEXT */)
                                            ])
                                        ])
                                    ])
                                ], 64 /* STABLE_FRAGMENT */))
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "cart-gift__more" }, [
                        _createElementVNode("a", {
                            href: "/gifts/",
                            class: "btn btn--4 btn--s btn--black btn--link"
                        }, [
                            _createElementVNode("span", { class: "btn__label" }, "Подробнее о подарках")
                        ])
                    ], -1 /* CACHED */))
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (__props.giftable.length)
                    ? (_openBlock(), _createBlock(GiftsModal, {
                        key: 0,
                        ref_key: "modal",
                        ref: modal,
                        giftable: __props.giftable,
                        gifts: __props.gifts,
                        giftsUsed: __props.giftsUsed,
                        giftsLeft: __props.giftsLeft,
                        vipAvailable: __props.vipAvailable
                    }, null, 8 /* PROPS */, ["giftable", "gifts", "giftsUsed", "giftsLeft", "vipAvailable"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
